import React, { useState, useContext, useEffect } from "react";
import "./CompanyChangePlan.css";
import api from "../../utils/api";
import { AuthorizedLayoutCompanies } from "../../components/AuthorizedLayoutCompanies";
import iconBack from "../../assets/Tipode material.png"
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../providers/AuthProvider";
import { toast } from "react-toastify";
import PaymentCheckoutModal from "./PaymentCheckoutModal";
import PlansSelection from "./components/PlansSelection/PlansSelection";

const CompanyChangePlan = () => {
  const { user, updateUser } = useContext(AuthContext);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPriceForModal, setSelectedPriceForModal] = useState(null);
  const [selectedPlanForModal, setSelectedPlanForModal] = useState(null);
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  const breadcrumbBase = {
    '/companies/settings?tab=plan': "Plano",
    '/companies/settings/change-plan': "Alterar Plano",
  };

  useEffect(() => {
    fetchPlans();
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    try {
      const response = await api.get(`/companies/companies/${user.id}`);

      if (response?.data && updateUser) {
        await updateUser(response.data);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchPlans = async () => {
    try {
      const { data } = await api.get("/companies/payment_plans");
      if (data?.data) {
        const plansList = data.data.map(item => ({
          id: item.id,
          ...item.attributes
        }));
        setPlans(plansList);
      }
    } catch (error) {
      console.error("Erro ao buscar planos:", error);
    }
  };

  const handlePriceSelect = async (priceId) => {
    try {
      let selectedPrice = null;
      let selectedPlan = null;

      for (const plan of plans) {
        const price = plan.prices?.find(p => p.id === priceId);
        if (price) {
          selectedPrice = price;
          selectedPlan = plan;
          break;
        }
      }

      if (!selectedPrice || !selectedPlan) {
        toast.error("Erro ao selecionar o plano. Tente novamente.");
        return;
      }

      const { data } = await api.get("/companies/has_payment_method");
      const hasCard = data?.data?.attributes?.hasPaymentMethod || false;

      setHasPaymentMethod(hasCard);
      setSelectedPriceForModal(selectedPrice);
      setSelectedPlanForModal(selectedPlan);
      setShowPaymentModal(true);
    } catch (error) {
      console.error("Erro ao verificar método de pagamento:", error);
      toast.error("Erro ao processar solicitação. Tente novamente.");
    }
  };

  const handleBack = () => {
    navigate("/companies/settings?tab=plan");
  };

  const handleModalSuccess = async () => {
    setShowPaymentModal(false);
    setSelectedPlanForModal(null);
    setSelectedPriceForModal(null);

    try {
      const response = await api.get(`/companies/companies/${user.id}`);

      if (response?.data && updateUser) {
        await updateUser(response.data);
      }

      navigate("/companies/settings?tab=plan");
    } catch (error) {
      navigate("/companies/settings?tab=plan");
    }
  };

  const handleModalCancel = () => {
    setShowPaymentModal(false);
    setSelectedPlanForModal(null);
    setSelectedPriceForModal(null);
  };

  return (
    <>
      <AuthorizedLayoutCompanies>
        <div className="containerCompanyChangePlan">
        <div className="headerCompanyChangePlan">
          <div>
            <div className="titlePanel">Alterar Plano</div>
          </div>
          <div className="breadcrumbContainer">
            <div className="buttonBreadcrumb" onClick={handleBack}>
              <img src={iconBack} alt="" />
            </div>
            <div className="breadcrumb">{breadcrumbBase['/companies/settings?tab=plan']} / <span className="active">Alterar Plano</span></div>
          </div>
        </div>

        <PlansSelection
          onPriceSelect={handlePriceSelect}
          plans={plans}
          showCurrentPlan={true}
        />
        </div>
      </AuthorizedLayoutCompanies>

      {showPaymentModal && selectedPlanForModal && selectedPriceForModal && (
        <PaymentCheckoutModal
          selectedPrice={selectedPriceForModal}
          selectedPlan={selectedPlanForModal}
          plans={plans}
          currentPlanId={user?.subscription?.paymentPlan?.id}
          hasPaymentMethod={hasPaymentMethod}
          onSuccess={handleModalSuccess}
          onCancel={handleModalCancel}
        />
      )}
    </>
  );
};

export default CompanyChangePlan;

